<script>
export default {
  name: 'TrueFalseLabel',
  props: {
    item: {
      type: [Boolean, Object],
      default: false,
    },
    labels: {
      type: Object,
      default: () => ({ yes: 'Yes', no: 'No' }),
    },
    revertColors: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Boolean,
      default: false,
    },
    class: {
      type: [String, Array, Object],
    },
  },
  computed: {
    someClass() {
      return this.class || ''
    },
  },
}
</script>

<template lang="pug">
span.text-black-15(v-if="hide" :class="someClass")
template(v-else)
  span(:class="someClass")
    span.badge(v-if="!!item" :class="revertColors ? 'no' : 'yes'") {{ labels['yes'] }}
    span.badge(v-else :class="revertColors ? 'yes' : 'no'") {{ labels['no'] }}
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.badge {
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px !important;
  letter-spacing: 0.2px;

  &.yes {
    background: #00b052;
    .erebus-app[data-theme='dark'] & {
      background: #00b052;
    }
  }

  &.no {
    background: map.get(themeVariables.$colors, error);
  }
}
</style>
